var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14 1.75V5.25",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7 1.75V5.25",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M2.625 7.875H18.375",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 3.5H4.375C3.40812 3.5 2.625 4.28312 2.625 5.25V16.625C2.625 17.5919 3.40812 18.375 4.375 18.375H16.625C17.5919 18.375 18.375 17.5919 18.375 16.625V5.25C18.375 4.28312 17.5919 3.5 16.625 3.5Z",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M6.13682 11.1379C6.01607 11.1379 5.91807 11.2359 5.91895 11.3567C5.91895 11.4774 6.01695 11.5754 6.1377 11.5754C6.25845 11.5754 6.35645 11.4774 6.35645 11.3567C6.35645 11.2359 6.25845 11.1379 6.13682 11.1379",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M10.5118 11.1379C10.3911 11.1379 10.2931 11.2359 10.2939 11.3567C10.2939 11.4774 10.3919 11.5754 10.5127 11.5754C10.6334 11.5754 10.7314 11.4774 10.7314 11.3567C10.7314 11.2359 10.6334 11.1379 10.5118 11.1379",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M14.8868 11.1379C14.7661 11.1379 14.6681 11.2359 14.6689 11.3567C14.6689 11.4774 14.7669 11.5754 14.8877 11.5754C15.0084 11.5754 15.1064 11.4774 15.1064 11.3567C15.1064 11.2359 15.0084 11.1379 14.8868 11.1379",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M6.13682 14.6379C6.01607 14.6379 5.91807 14.7359 5.91895 14.8567C5.91895 14.9774 6.01695 15.0754 6.1377 15.0754C6.25845 15.0754 6.35645 14.9774 6.35645 14.8567C6.35645 14.7359 6.25845 14.6379 6.13682 14.6379",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M10.5118 14.6379C10.3911 14.6379 10.2931 14.7359 10.2939 14.8567C10.2939 14.9774 10.3919 15.0754 10.5127 15.0754C10.6334 15.0754 10.7314 14.9774 10.7314 14.8567C10.7314 14.7359 10.6334 14.6379 10.5118 14.6379",
    stroke: "#B6B6B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.2298c33df70c436eed1354d777b63c64.svg";
export { ForwardRef as ReactComponent };